import React, { useRef, useState } from 'react';
import FormFields from '../../../Forms/FormFields';
import './UserPage1.css';
import Button from '../../../../components/common/Button';
import CustomTooltip from '../../../../components/common/CustomTooltip';
import PlusSvgIcon from './../../../../assets/svg/plus.svg';
import CommonFormFields from '../../../Forms/CommonFormFields';
import { updateForm } from '../../../../store/actions/userManagementAction';
import { useDispatch } from 'react-redux';
import profilePic from '../../../../assets/png/default_profile.png'
import InfoBar from './../../../../components/common/InfoBars';

type propsType = {
  formData: {
    [key: string]: any;
  };
  formState1:any;
  handleFormChange1:(value: any, key: string, id: any, option: any, code: any)=>void;
};

const UserPage1 = ({ formData,formState1,handleFormChange1 }: propsType) => {
  const dispatch=useDispatch();
  
  const [verify, setVerify] = useState<boolean>(false);
  const [imageError, setImageError] = useState('');
  const inputRef  = useRef<any>(null);
 
  const [uploadMethod, setUploadMethod] = useState<'local' | 'url' | null>(
    null,
  );
  const [imageUrl, setImageUrl] = useState<string>('');

  const handleFileChange = async(event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files && event.target.files[0];
    setImageError('');
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if(fileSize > 1048576) {
        setImageError('File size must be less than or equal to 1MB');
        return;
      }
      if(!['image/jpeg', 'image/png', 'image/jpg'].includes(fileType)) {
        setImageError('Only JPG, JPEG and PNG images are allowed');
        return;
      }
      setImageUrl(URL.createObjectURL(selectedFile));
      setUploadMethod(null);
      const file = selectedFile;
      const formData = new FormData()
      formData.append('file',selectedFile);
      dispatch(updateForm("file",formData));
    }
  };

  const handleUploadClick = (method: 'local' | 'url') => {
    inputRef.current?.click();
    setUploadMethod(method);
  };
  return (
    <div className="user_details_form_page">
      <div className="profile-uploader-user-page1">
        {
          imageUrl ? <div
          className="profile-picture-user-page1"
          style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : '' }}
        ></div> : <img
          className="profile-uploader-user-page1"
          src={profilePic}
          alt='Profile Image'
        />
        }
        <div>
          <div className='button-tooltip'>
          <Button
            onClick={() => handleUploadClick('local')}
            disabled={false}
            id="add-profile-picture"
            buttonName={'Add Profile Picture '}
            colorType={'primary'}
            icon={<PlusSvgIcon />}
            iconPosition={'left'}
          />
          <span className='tooltip-profile-pic'><CustomTooltip text={'File size must be less than or equal to 1MB and Only JPG, JPEG and PNG images are allowed'}/></span>
          </div>
         
          {imageError.length > 0 && <InfoBar
              variant="danger"
              message={imageError}
              className="input_field_class profile-pic-error"
          />}
        </div>
        <input
          type="file"
          accept=".jpg,.jpeg,.png"
          onChange={handleFileChange}
          className="profile-picture-hidden-input"
          ref={inputRef}
        />
      </div>
      <form className="form_container_user_details">
        <CommonFormFields
          formData={formData}
          formState={formState1}
          handleFormChange={handleFormChange1}
          verified={verify}
        />
      </form>
    </div>
  );
};
export default UserPage1;
